module.exports = __webpack_public_path__ + "static/img/1.14c688d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/1.png
// module id = +3kR
// module chunks = 0